import { getURLParams } from './';

export const retrieveAuthCode = (
  url: string,
  redirectUrl: string
): string | null => {
  if (!url) return null;
  const params = getURLParams(url);
  if (url.startsWith(redirectUrl) && params['code']) {
    return params['code'];
  }

  return null;
};
